import { render, staticRenderFns } from "./TopFive.vue?vue&type=template&id=c8bebc78&scoped=true&"
import script from "./TopFive.vue?vue&type=script&lang=js&"
export * from "./TopFive.vue?vue&type=script&lang=js&"
import style0 from "./TopFive.vue?vue&type=style&index=0&id=c8bebc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bebc78",
  null
  
)

export default component.exports